import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { createCheckout } from "../lib/api";

export const BuyButton = ({ className = "", children, testId = "buy-now-button" }) => {
  const [loading, setLoading] = useState(false);

  const handleBuy = async () => {
    setLoading(true);
    try {
      const { checkout_url } = await createCheckout({
        lookup_key: "thortek_lifetime",
        origin_url: window.location.origin,
      });
      if (checkout_url) {
        window.location.href = checkout_url;
      } else {
        throw new Error("No checkout URL returned");
      }
    } catch (e) {
      toast.error("Could not start checkout. Please try again.");
      setLoading(false);
    }
  };

  return (
    <button
      data-testid={testId}
      onClick={handleBuy}
      disabled={loading}
      className={`inline-flex items-center justify-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed transition-all ${className}`}
    >
      {loading ? <Loader2 size={18} className="animate-spin" /> : null}
      {children}
    </button>
  );
};
